import { render } from "./BrandImage.vue?vue&type=template&id=11b18f3b&scoped=true"
import script from "./BrandImage.vue?vue&type=script&lang=js"
export * from "./BrandImage.vue?vue&type=script&lang=js"

import "./BrandImage.vue?vue&type=style&index=0&id=11b18f3b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b18f3b"]])

export default __exports__